export default "__VITE_ASSET__bb45ed81__"